"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.observable = function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();